module.exports = global["ReactDOM"] = require("-!./index.js");


//////////////////
// WEBPACK FOOTER
// /home/jenkins/agent/workspace/eb-apps_b2c-site_b2c-site_master/node_modules/expose-loader?ReactDOM!/home/jenkins/agent/workspace/eb-apps_b2c-site_b2c-site_master/node_modules/react-dom/index.js-exposed
// module id = 1339
// module chunks = 81